import React, { Component } from 'react'
import { connect } from 'react-redux'
import Part from './../Part'
import Line from './../Line'
import PriceLine from './../PriceLine'
import DecimalInput from '../../DecimalInput'
import PriceApprovalModal from '../../../modals/PriceApprovalModal'
import ConfirmPriceChanges from '../../../components/ConfirmPricechanges'
import Photo from '../Photo'
import Comment from '../Comment'

import Portal from '../../../components/Portal'
import { translation } from '../../../../utils/helpers'
import { renderFullDate } from '../../../../utils/time'
import { hasAccess, hasSubscriptionPermission, hasPartnerSubscriptionPermission } from '../../../../utils/auth'
import { TransportTypeIcons } from '../../../elements/icons'

import EventEmitter from '../../../../utils/events'

import './price.scss'

import Button from '../../../elements/button'
import Check from '../../../elements/check'
import Divider from '../../../elements/divider'
import Radio from '../../../elements/radio'
// import DropDown from '../../../elements/dropDown'
import Icon from '../../../elements/icon'
import Inline from '../../../elements/inline'
// import Text from '../../../elements/text'

class Price extends Component {
  constructor (props) {
    super(props)
    this.state = {
      showNet: false,
      isLoosePart: false,
      newTask: {
        TaskPriceId: 0,
        BodyTaskPriceId: 0,
        OrderTaskId: 0,
        PartItemId: 0,
        TaskName: ''
      },
      hasChanged: false,
      initialTaskCount: null,
      visibleGroups: {
        gross1: false,
        gross2: false,
        total: false
      },
      gross_shop_radio: 'DiscountShop',
      gross_customer_radio: 'DiscountCustomer',
      // shopMustApprove: null,
      confirmDialog: {
        open: false
        // noApproval: false
      }
    }

    this.saveOrderPrice = this.saveOrderPrice.bind(this)
    this.resetNewItem = this.resetNewTask.bind(this)
    this.changeValue = this.changeValue.bind(this)
    this.onRadioChange = this.onRadioChange.bind(this)
    this.backToWorkcard = this.backToWorkcard.bind(this)
  }

  componentDidMount () {
    this.props.onRef(this)
  }

  componentWillUnmount () {
    this.props.onRef(undefined)
  }

  getTitle () {
    if (this.props.orderPrice === null) return null
    if (this.props.orderPrice.IsAddonPrice) {
      return translation(1396)
    }
    switch (this.props.order.OrderType) {
      case 2:
        return translation(71)
      case 3:
        return translation(13361)
      case 6:
        return translation(785)
    }
    return 'No title'
  }

  getTitleAria () {
    if (this.props.orderPrice === null) return null
    if (this.props.orderPrice.IsAddonPrice) {
      return translation(34) + ' ' + translation(1396)
    }
    return translation(2705)
  }

  getIcon () {
    if (this.props.orderPrice === null) return null
    if (this.props.orderPrice.IsAddonPrice) {
      return '/images/svgs/taksering/Additional-sales-new.svg'
    }
    switch (this.props.order.OrderType) {
      case 2:
        return '/images/svgs/ordrer/Salescar-black.svg'
      case 3:
        return '/images/svgs/ordrer/Garanteed-black.svg'
      case 6:
        return '/images/svgs/ordrer/Private_c-black.svg'
    }
    return null
  }

  getEditUrl () {
    if (this.props.order !== null && (this.props.department === 0 && this.props.order.IsAssessmentOk === true) || (this.props.department === 1 && this.props.order.IsBodyShopAssessmentOk)) return null
    // if (this.props.order !== null && this.props.order.IsReferredIn === true) return null
    if (this.props.orderPrice === null) return null
    if (hasAccess([6], this.props.auth.user.UserType)) return null
    if (this.props.order !== null && (hasAccess([4], this.props.auth.user.UserType) || hasAccess([3, 5, 7], this.props.auth.user.UserType) && this.props.auth.user.DepartmentType === 1) && this.props.order.IsDraft !== true && this.props.orderPrice.Department === 0) return null
    if (this.props.orderPrice.Department === 1) {
      return '/pricecalculation/' + this.props.order.Id + '/bodyextent'
    }
    return '/pricecalculation/' + this.props.order.Id + '/1'
  }

  resetNewTask () {
    this.setState({
      newTask: {
        TaskPriceId: 0,
        BodyTaskPriceId: 0,
        OrderTaskId: 0,
        PartItemId: 0,
        TaskName: ''
      }
    })
  }

  /**
   * Change value, and save orderprice
   * @param {object} args Object in the format: { name, value }
   */
  changeValue (args) {
    let orderPrice = this.props.orderPrice
    if (orderPrice[args.name] === args.value) return

    let state = this.state
    switch (args.name) {
      case 'Net':
        orderPrice.CustomerNetOrDiscount = 1
        state.gross_shop_radio = args.name
        break
      case 'DiscountShop':
        orderPrice.CustomerNetOrDiscount = 0
        state.gross_shop_radio = args.name
        break
      case 'NetCustomer':
        orderPrice.CustomerNetOrDiscount = 1
        state.gross_customer_radio = args.name
        break
      case 'DiscountCustomer':
        orderPrice.CustomerNetOrDiscount = 0
        state.gross_customer_radio = args.name
        break
      case 'Total':
        orderPrice.HoldTotal = true
        break
    }
    this.setState({
      gross_shop_radio: state.gross_shop_radio,
      gross_customer_radio: state.gross_customer_radio
    }, () => {
      orderPrice[args.name] = args.value
      this.saveOrderPrice(orderPrice)
    })
  }

  onRadioChange (e) {
    // console.log('radio change', e.target.name, e.target.value)
    this.setState({[e.target.name]: e.target.value})
  }

  componentWillReceiveProps (newProps) {
    let orderPrice = newProps.orderPrice

    this.setState({
      isLoosePart: orderPrice ? orderPrice.IsLoosePart : false,
      visibleGroups: {
        ...this.state.visibleGroups,
        gross1: newProps.showNet
      }
    })
  }

  saveOrderPrice (orderPrice, stripTasks = false, stripExtras = false, stripServices) {
    return new Promise((resolve, reject) => {
      if (this.displayOnly()) {
        resolve()
        return
      }
      orderPrice.IsLoosePart = this.state.isLoosePart

      if (stripTasks) {
        orderPrice.Parts = []
      }

      if (stripExtras) {
        orderPrice.Extras = []
      }

      if (stripServices) {
        orderPrice.Services = []
      }
      if (!this.props.isCustomer) {
        switch (this.state.gross_shop_radio) {
          case 'DiscountShop':
            orderPrice.CustomerNetOrDiscount = 0
            break
          case 'Net':
            orderPrice.CustomerNetOrDiscount = 1
            break
        }
      } else {
        switch (this.state.gross_customer_radio) {
          case 'DiscountCustomer':
            orderPrice.CustomerNetOrDiscount = 0
            break
          case 'NetCustomer':
            orderPrice.CustomerNetOrDiscount = 1
            break
        }
      }
      // console.log('orderPrice', this.state.gross_shop_radio, '---> CustomerNetOrDiscount', orderPrice.CustomerNetOrDiscount)
      this.props.saveOrderPrice(orderPrice).then((res) => {
        this.resetNewTask()
        resolve(res)
        return
      }, (err) => {
        reject(err)
        return
      })
    })
  }

  displayOnly () {
    let result = !this.props.editable || this.props.orderPrice.HasAwaiting === true
    return result
  }

  allowEdit () {
    let result = !this.displayOnly() && (!this.props.isCustomer || this.props.order.IsDraft)
    return result
  }

  // Back to workcard function
  backToWorkcard (skipPriceChangeCheck) {
    let orderPrice = this.props.orderPrice
    const confirmChangeAndGoBack = () => {
      if (!this.props.order.IsDraft /* && !orderPrice.IsAddonPrice */) {
        // let noApproval = false
        // if (!orderPrice.RequireShopApproval && orderPrice.HasChanged) {
        //   noApproval = true
        // }
        if (orderPrice.RequireShopApproval /* || orderPrice.HasChanged */) {
          this.setState({
            // shopMustApprove: true,
            confirmDialog: {
              // mustApprove: true,
              open: true
              // noApproval: noApproval
            }
          })
        } else {
          this.props.goBack()
        }
      } else {
        this.props.goBack()
      }
    }

    if (!this.displayOnly()) {
      setTimeout(() => {
        // Price/price changes
        let orderPrice = this.props.orderPrice
        if (orderPrice.RequireShopApproval) {
          // priceObj.SendToApproval = true
        }
        this.saveOrderPrice(orderPrice).then(() => {
          confirmChangeAndGoBack()
        })
      }, 800)
    } else {
      this.props.goBack()
    }
  }

  renderConfirm () {
    const onClose = (goBack = true) => {
      this.setState({
        confirmDialog: {
          ...this.state.confirmDialog,
          open: false
        }
      })
      if (goBack) this.props.goBack()
    }

    // console.log('renderConfirm', this.state.confirmDialog, this.props.orderPrice.RequireCustomerApproval, this.props.orderPrice.RequireShopApproval)
    if (this.state.confirmDialog.open) {
      if (this.props.orderPrice.RequireShopApproval) {
        return (<PriceApprovalModal orderId={this.props.order.Id} show={this.state.confirmDialog.open && this.props.orderPrice.RequireShopApproval === true} closeModal={onClose.bind(this, false)} overflowHidden={false} />)
      } else {
        return (
          <Portal className='confirm_popup' onPortalClose={() => { return }}>
            <ConfirmPriceChanges changes={this.props.orderPrice.RequireCustomerApproval} confirm={onClose.bind(this)} />
          </Portal>
        )
      }
    }
  }

  renderOkButton () {
    let orderPrice = this.props.orderPrice
    // console.log('renderOkButton', orderPrice.RequireApproval, orderPrice.HasAwaiting)
    if (orderPrice.RequireApproval) {
      return <Button onClick={this.backToWorkcard.bind(this)} labelText={translation('791')} />
    } else if (orderPrice.HasAwaiting) {
      return <div className='spacing'>{translation('1320')} {renderFullDate(orderPrice.CreatedDate, true)}</div>
    } else {
      return <Button onClick={this.backToWorkcard.bind(this)} labelText={translation('956')} />
    }
  }

  render () {
    // let isCustomer = this.props.isCustomer
    let orderPrice = null
    if (this.props.orderPrice) {
      orderPrice = {...this.props.orderPrice}
    }

    if (orderPrice === undefined || orderPrice === null) return null
    const toggleNet = () => {
      this.setState({showNet: !this.state.showNet})
    }
    const renderInnerTitle = () => {
      let showPrices = this.props.order.ShowPrices || this.props.editable
      let canToggleNet = this.props.orderPrice.Department === 0 && showPrices
      // let netGrossTxt = this.state.showNet ? translation('13351') : translation('13350')
      let title = '' // translation(889)
      if (this.props.overrideInnerTitle !== null) {
        title = this.props.overrideInnerTitle
      }
      return (
        // <div className='h-line title'>
        <div>
          {title}
          {/* {canToggleNet && <Button style='link' onClick={toggleNet} labelText={netGrossTxt} />} */}
          {canToggleNet && <Check checked={this.state.showNet} onChange={toggleNet} labelText={translation('13351')} />}
          {/* {canToggleNet && <button className='net-toggle' onClick={toggleNet}>{netGrossTxt}</button>} */}
        </div>
      )
    }

    /**
     * Sets IsDeleted of an item
     * @param {object} item
     */
    const onDelete = (item) => {
      if (this.allowEdit()) {
        item.IsDeleted = true
        this.saveOrderPrice(orderPrice)
      }
    }

    /**
     * Reduces Count of an item (and marks IsDeleted if 0)
     * @param {object} item
     */
    const onReduce = (item) => {
      if (this.allowEdit() && item.Count > 0) {
        item.Count--
        if (item.Count === 0) item.IsDeleted = true
        this.saveOrderPrice(orderPrice)
      }
    }

    const renderStartPrice = () => {
      let amount = (this.props.isWp && this.props.showAgreementPrice) ? orderPrice.StartPriceGrossWP : orderPrice.StartPrice
      if (this.state.showNet) {
        amount = (this.props.isWp && this.props.showAgreementPrice) ? orderPrice.StartPriceNetWP : orderPrice.StartPriceNet
      }

      let showPrices = this.props.order.ShowPrices || this.props.editable
      if (!showPrices) amount = ''
      return <Line text={translation('13378')} amount={amount} />
    }

    const renderEnvironment = () => {
      let amount = (this.props.isWp && this.props.showAgreementPrice) ? orderPrice.EnvironmentWP : orderPrice.Environment
      if (this.state.showNet) {
        amount = (this.props.isWp && this.props.showAgreementPrice) ? orderPrice.EnvironmentNetWP : orderPrice.EnvironmentNet
      }
      return <Line text={translation('13339')} amount={amount} />
    }

    const renderShopGross = () => {
      let amount = orderPrice.Gross
      let discountField = 'DiscountShop'
      let netField = 'Net'
      if (this.props.isWp && this.props.showAgreementPrice) {
        amount = orderPrice.GrossWP
        discountField = 'DiscountWP'
        netField = 'NetWp'
      }
      if (this.props.isCustomer) {
        discountField = 'Discount'
      }

      // Rendering shop discount/net fold-out for editing
      if (!this.displayOnly()) {
        const renderRadio = (fieldName, label) => {
          return (
            <Radio spacing={1} labelText={label} name='gross_shop_radio' value={fieldName} checked={this.state.gross_shop_radio === fieldName} onChange={this.onRadioChange} />
          )
        }

        let editable = true
        if (this.props.isCustomer || this.props.order.IsAgreementOrder || this.props.order.IsAgreement) {
          editable = false
        }
        if (this.props.department === 0 && this.props.auth.departmentType === 1 && this.props.auth.hasPartner) {
          editable = false
        }

        const renderEdit = (fieldName) => {
          return (
            <div className='amount blue'>
              <DecimalInput size='s' className={fieldName.toLowerCase()} value={orderPrice[fieldName]} name={fieldName} onBlur={this.changeValue} />
            </div>
          )
        }

        // Render text part of the line (text or radio)
        const renderText = (fieldName) => {
          let label = ''
          switch (fieldName) {
            case 'DiscountShop':
              label = translation(15014)
              break
            case 'Net':
              label = translation(1392)
              break
            case 'Discount':
              label = translation(1199)
              break
          }

          // if (this.props.isCustomer || this.props.order.IsAgreementOrder) return label
          if (!editable) return label
          return renderRadio.bind(this, fieldName, label)
        }

        // Render amount part of the line (text or input)
        const renderAmount = (fieldName) => {
          // if (this.props.isCustomer || this.props.order.IsAgreementOrder) return orderPrice[fieldName]
          if (!editable) return orderPrice[fieldName]
          return renderEdit.bind(this, fieldName)
        }

        return (
          <Line text={translation('13376')} amount={amount} isBlue canExpand>
            <Line text={renderText(discountField)} amount={renderAmount(discountField)} />
            <Line text={renderText(netField)} amount={renderAmount(netField)} />
            <Line text={translation(2142)} amount={orderPrice.NetExclEnvironment} isBlue />
          </Line>
        )
      }
      // Only showing gross
      return <Line text={translation('13376')} amount={amount} />
    }

    const renderShopDiscount = () => {
      let amount = orderPrice.DiscountShop
      if (this.props.isWp && this.props.showAgreementPrice) amount = orderPrice.DiscountWP
      return <Line text={translation('1199') + ' (%)'} amount={amount} />
    }

    const renderShopNet = () => {
      let amount = orderPrice.Net
      if (this.props.isWp && this.props.showAgreementPrice) amount = orderPrice.NetWP
      return <Line text={translation('1392')} amount={amount} />
    }

    const renderCustomerGross = () => {
      let amount = orderPrice.GrossCustomer
      let discountField = 'DiscountCustomer'
      let netField = 'NetCustomer'

      // Rendering customer discount/net fold-out for editing
      if (this.allowEdit()) {
        const renderRadio = (fieldName, label) => {
          return (
            <Radio spacing={1} labelText={label} name='gross_customer_radio' value={fieldName} checked={this.state.gross_customer_radio === fieldName} onChange={this.onRadioChange} />
          )
        }
        const renderEdit = (fieldName) => {
          return (
            <div className='amount blue'>
              <DecimalInput size='s' className={fieldName.toLowerCase()} value={orderPrice[fieldName]} name={fieldName} onBlur={this.changeValue} />
            </div>
          )
        }

        // Render text part of the line (text or radio)
        const renderText = (fieldName) => {
          let label = ''
          switch (fieldName) {
            case 'DiscountCustomer':
              label = translation(15014)
              break
            case 'NetCustomer':
              label = translation(1392)
              break
          }

          return renderRadio.bind(this, fieldName, label)
        }

        // Render amount part of the line (text or input)
        const renderAmount = (fieldName) => {
          return renderEdit.bind(this, fieldName)
        }

        return (
          <Line text={translation('393')} amount={amount} canExpand>
            <Line text={renderText(discountField)} amount={renderAmount(discountField)} />
            <Line text={renderText(netField)} amount={renderAmount(netField)} />
          </Line>
        )
      }

      return <Line text={translation('393')} amount={amount} />
    }

    const renderCustomerDiscount = () => {
      let amount = orderPrice.DiscountCustomer
      return <Line text={translation('15014')} amount={amount} />
    }

    const renderCustomerNet = () => {
      let amount = orderPrice.NetCustomer
      return <Line text={translation('1392')} amount={amount} />
    }

    const renderVat = () => {
      let amount = orderPrice.Vat
      if (this.props.isWp && this.props.showAgreementPrice) amount = orderPrice.VatWP
      return <Line text={translation('13390')} amount={amount} isVat />
    }

    const renderTotal = () => {
      let fieldName = 'Total'
      if (this.props.isWp && this.props.showAgreementPrice) {
        fieldName = 'TotalWP'
      }
      let amount = orderPrice[fieldName]

      let editable = true
      if (this.props.order.IsAgreementOrder || this.props.order.IsAgreement) {
        editable = false
      }
      if (this.props.department === 0 && this.props.auth.departmentType === 1 && this.props.auth.hasPartner) {
        editable = false
      }
      if (!this.displayOnly() && /* !this.props.order.IsAgreementOrder */ editable) {
        const renderEdit = (fieldName) => {
          return (
            <div className='amount'>
              <DecimalInput size='s' className={fieldName.toLowerCase()} value={orderPrice[fieldName]} name={fieldName} onBlur={this.changeValue} />
            </div>
          )
        }
        return (
          <Line text={translation('393')} amount={amount} amountOpen={''} canExpand bold>
            <Line text={''} amount={renderEdit.bind(this, fieldName)} />
          </Line>
        )
      }

      return <Line text={translation('393')} amount={amount} bold />
    }

    const renderOwnServicesGross = () => {
      let amount = orderPrice.GrossServices
      return <Line text={translation('13376')} amount={amount} />
    }

    const renderDivider = (text) => {
      if (text !== undefined) {
        return (
          <div className='title spacing'>{text}</div>
        )
      }
      return (
        <div className='h-line bold' />
      )
    }

    const renderParts = (includeNormalParts = true, includeOtherPart = true) => {
      let parts = []
      if (includeNormalParts) {
        orderPrice.Parts.filter(p => p.Part.PartItemId > 0).map(p => { parts.push(renderPart(p)) })
      }
      if (includeOtherPart) {
        orderPrice.Parts.filter(p => p.Part.PartItemId === 0).map(p => { parts.push(renderPart(p)) })
      }
      return parts
    }

    const renderPart = (item) => {
      return <Part
        {...this.props}
        key={'part_' + item.Part.PartItemId + '_' + item.Part.TaskSide}
        part={item}
        saveOrderPrice={this.saveOrderPrice}
        onDelete={this.allowEdit() ? onDelete : undefined}
        showNet={this.state.showNet}
        noPrice={this.props.viewMode === 'simple'}
        />
    }

    const renderServiceTask = (item) => {
      if (item.OrderServiceTaskId === undefined) return null
      let key = 'service_' + item.OrderServiceTaskId
      if (item.IsExtra) key = 'extra_' + item.OrderServiceTaskId
      return <PriceLine
        {...this.props}
        key={key}
        orderServiceTask={item}
        saveOrderPrice={this.saveOrderPrice}
        onDelete={this.allowEdit() ? onReduce : undefined}
        showNet={this.state.showNet}
        noPrice={this.props.viewMode === 'simple'}
        />
    }

    const renderAddonPart = (item) => {
      if (item.OrderAddonPartId === undefined) return null
      return <PriceLine
        {...this.props}
        key={'addonpart_' + item.OrderAddonPartId}
        orderAddonPart={item}
        saveOrderPrice={this.saveOrderPrice}
        onDelete={this.allowEdit() ? onDelete : undefined}
        showNet={this.state.showNet}
        noPrice={this.props.viewMode === 'simple'}
        />
    }

    const renderAddonStartTime = (item) => {
      if (item.OrderAddonStartTimeId === undefined) return null
      return <PriceLine
        {...this.props}
        key={'addonstarttime_' + item.OrderAddonStartTimeId}
        orderAddonStartTime={item}
        saveOrderPrice={this.saveOrderPrice}
        onDelete={this.allowEdit() ? onDelete : undefined}
        showNet={this.state.showNet}
        noPrice={this.props.viewMode === 'simple'}
        />
    }

    const renderNewItem = () => {
      let item = {...this.state.newTask}
      return (
        <PriceLine
          {...this.props}
          orderTaskPrice={item}
          saveOrderPrice={this.saveOrderPrice}
          showNet={this.state.showNet}
         />
      )
    }

    const renderToggleLoosePart = () => {
      const toggle = () => {
        let isLoosePart = this.state.isLoosePart
        this.setState({
          isLoosePart: !isLoosePart,
          hasChanged: true
        }, () => {
          this.saveOrderPrice(this.props.orderPrice)
        })
      }

      return (
        <Inline fillChildNum={[0]} alignChildren='center' block>
          <div>{translation('351')}</div>
          <Check labelAlignment='l' labelText={(<Icon icon={TransportTypeIcons.Loose_Part} />)} id={'IsLoosePart_check'} name='IsLoosePart_check' checked={this.state.isLoosePart} disabled={this.props.isCustomer && !this.props.order.IsDraft && !this.displayOnly()} onChange={toggle} />
        </Inline>
      )
    }

    const renderSendMailButton = () => {
      const emailClick = () => {
        EventEmitter.emit('Price_Email_Click')
      }
      return (
        this.props.order.IsDraft && (
          <div onClick={emailClick} style={{ textAlign: 'right', marginTop: 6, cursor: 'pointer' }}>
            <img src={'/images/svgs/Messages-send.svg'} width={22} />
          </div>
        )
      )
    }

    const renderPhotoAndComments = () => {
      let hasCommentAndPhotoAccess = hasSubscriptionPermission(this.props.auth, 10)
      if (this.props.auth.departmentType === 1 && this.props.department === 0 && this.props.auth.hasPartner) {
        hasCommentAndPhotoAccess = hasPartnerSubscriptionPermission(this.props.auth, 10)
      }
      if (!hasCommentAndPhotoAccess) return null

      const comment = this.props.orderPrice.Notes.find(n => n.SourceID === 11)
      return (
        <div>
          <Photo saveOrderPrice={this.props.saveOrderPrice} orderPrice={this.props.orderPrice} order={this.props.order} />
          <Comment comment={comment} changeSource={11} orderPriceId={this.props.orderPrice.OrderPriceId} order={this.props.order} />
        </div>
      )
    }

    const renderShop = () => {
      // let isPriceChange = this.props.orderPrice.ApprovalShop === 1 || this.props.orderPrice.ApprovalCustomer === 1
      let showPrices = this.props.order.ShowPrices || this.props.editable
      let isCorrectViewMode = !['hover', 'simple'].includes(this.props.viewMode)
      return (
        <div>
          <div className='totals shop'>
            {isCorrectViewMode && showPrices && renderEnvironment()}
            <Divider />
            {isCorrectViewMode && showPrices && renderShopGross()}
            {isCorrectViewMode && showPrices && this.displayOnly() && renderShopDiscount()}
            {isCorrectViewMode && showPrices && this.displayOnly() && renderShopNet()}
            {this.props.viewMode !== 'simple' && showPrices && renderVat()}
            {showPrices && <Divider />}
            {/* {showPrices && renderDivider()} */}
            {showPrices && renderTotal()}
            {this.props.editable && renderPhotoAndComments()}
          </div>
        </div>
      )
    }

    const renderCustomer = () => {
      let showPrices = this.props.order.ShowPrices || this.props.editable
      let isCorrectViewMode = !['hover', 'simple'].includes(this.props.viewMode)
      let isPaint = this.props.auth.departmentType === 0
      return (
        <div>
          <div className='totals shop'>
            {isCorrectViewMode && showPrices && renderEnvironment()}
            <Divider />
            {isCorrectViewMode && showPrices && renderShopGross()}
            {isCorrectViewMode && showPrices && this.displayOnly() && renderShopDiscount()}
            {isCorrectViewMode && showPrices && this.displayOnly() && renderShopNet()}
          </div>
          {orderPrice.Services.length > 0 && (
            <div>
              {renderDivider(translation(13375))}
              {orderPrice.Services.map(renderServiceTask)}
              {isCorrectViewMode && renderOwnServicesGross()}
            </div>
          )}
          <div className='totals customer'>
            {isCorrectViewMode && isPaint && renderDivider(translation(13377))}
            {isCorrectViewMode && isPaint && renderCustomerGross()}
            {isCorrectViewMode && isPaint && !this.allowEdit() && renderCustomerDiscount()}
            {isCorrectViewMode && isPaint && !this.allowEdit() && renderCustomerNet()}
            {isCorrectViewMode && showPrices && renderVat()}
            {showPrices && <Divider />}
            {/* {showPrices && renderDivider()} */}
            {showPrices && renderTotal()}
            {this.props.editable && renderPhotoAndComments()}
          </div>
        </div>
      )
    }

    let css = ''
    if (this.props.editable) {
      css += 'price__view editable test'
    }
    return (
      <div className={css}>
        <form onSubmit={(e) => { e.preventDefault() }}>
          <div>
            {this.props.viewMode === 'mobile' && this.props.renderInside()}
            {renderInnerTitle()}
            {this.allowEdit() && !this.props.orderPrice.IsAddonPrice && renderToggleLoosePart()}
            {orderPrice.Department === 0 && renderStartPrice()}
            {renderParts(true, false)}
            {orderPrice.Extras.map(renderServiceTask)}
            {orderPrice.OrderAddonParts.map(renderAddonPart)}
            {orderPrice.OrderAddonStartTimes.map(renderAddonStartTime)}
            {renderParts(false, true)}
            {!this.props.isWp && this.allowEdit() && this.props.orderPrice.Department === 0 && renderNewItem()}
            {this.props.isCustomer ? renderCustomer() : renderShop()}
            {this.props.editable && this.renderOkButton()}
            {!this.props.isWp && this.allowEdit() && renderSendMailButton()}
          </div>
        </form>
        {this.renderConfirm()}
      </div>
    )
  }
}

Price.contextTypes = {
  router: React.PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}
export default connect(mapStateToProps, {})(Price)



// WEBPACK FOOTER //
// ./src/app/shared/components/Extent/Price/index.js